import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/schedule/debug')({
  staticData: { team: 'schedule' },
});
